<template>
  <div class="full-wrapper pannel">
    <el-scrollbar :ref="scrollbarRef">
      <div class="full">
        <w-operation-state-info :params="params" :rsc-info="operationStateParams" :active="active" :agent-list="agentList"/>
        <el-row>
          <div class="row">
            <el-col :md="12" :lg="12">
              <w-perf-widget :show-change-btn="false">
              <span slot="perfHeader">구성 정보</span>
              <div slot="perfBody">
                <el-col :md="24" :lg="12">
                  <table class="list-none-border">
                    <tr>
                      <th>E2E 서비스명</th>
                      <td>{{ configInfoData.serviceName }}</td>
                    </tr>
                    <tr>
                      <th>URL</th>
                      <td>{{ configInfoData.httpUrl }}</td>
                    </tr>
                    <tr>
                      <th>프로토콜</th>
                      <td>{{ configInfoData.protocol }}</td>
                    </tr>
                    <tr>
                      <th>수집방식</th>
                      <td>{{ configInfoData.method }}</td>
                    </tr>
                    <tr>
                      <th>파라미터</th>
                      <td>{{ configInfoData.httpParam }}</td>
                    </tr>
                  </table>
                </el-col>
                <el-col :md="24" :lg="12">
                  <table class="list-none-border">
                    <tr>
                      <th>문자열 정합성 여부</th>
                      <td>{{ configInfoData.adjustLabel }}</td>
                    </tr>
                    <!-- FIXME 설계 변경시 수정 필요 -->
                    <tr>
                      <th>에이전트명</th>
                      <td>{{ configInfoData.agentLabel }}</td>
                    </tr>
                    <tr>
                      <th>관리자 (정/부)</th>
                      <td>{{ configInfoData.majorLabel }}</td>
                    </tr>
                    <tr>
                      <th></th>
                      <td>{{ configInfoData.minorLabel }}</td>
                    </tr>
                  </table>
                </el-col>
              </div>
              <div slot="perfFooter">
                <span>최근 변경시각: {{ configInfoData.checkDatetimeLabel }}</span>
              </div>
              </w-perf-widget>
            </el-col>
            <el-col :md="12" :lg="12">
              <w-event-info-widget :event-info-data="eventInfoData"></w-event-info-widget>
            </el-col>
            <el-col> <!--:md="12" :lg="24" 삭제 20191021-->
              <w-perf-widget @change-widget-view="changeWidgetView('RESPONSETIME', ...arguments)" :show-change-btn="false" :eventlevel="responsetimeData.eventlevel">
              <el-row style="width: calc(100% - 40px);" type="flex" slot="perfHeader" justify="space-between">
                <span>Web 구간 별 성능</span>
                <el-select v-model="responsetimeSelectedAgent" placeholder="데이터가 없습니다.">
                  <el-option v-for="agent in agentList" :key="agent.value" :label="agent.objName" :value="agent.objId" />
                </el-select>
              </el-row>
              <!-- BODY -->
              <ul class="event-info-list" v-if="responsetimeViewIndex === 0" slot="perfBody">
                <w-perf-body-info v-for="data in responsetimeData.frontBody" :key="data.widgetKey" :widget-info="data" />
              </ul>
              <w-summary-area-chart v-else slot="perfBody" :series="responsetimeData.backBody"></w-summary-area-chart>
              <!-- FOOTER -->
              <ul class="multi" v-if="responsetimeViewIndex === 0" slot="perfFooter">
                <w-perf-footer-h-info v-for="data in responsetimeData.frontFooter" style="width: 100%;" :key="data.widgetKey" :widget-info="data" />
              </ul>
              <ul class="legend list" v-else slot="perfFooter">
                <w-perf-footer-v-info v-for="data in responsetimeData.backFooter" :key="data.widgetKey" :widget-info="data" :legend-info="{ isLegend: true, index: findFooterIndex(responsetimeData.backBody, data) }" />
              </ul>
              </w-perf-widget>
            </el-col>
            <el-col :md="12" :lg="12">
              <w-perf-widget @change-widget-view="changeWidgetView('AVAIL', ...arguments)" :show-change-btn="false" :eventlevel="availData.eventlevel">
              <el-row style="width: calc(100% - 40px);" type="flex" slot="perfHeader" justify="space-between">
                <span>{{ availViewIndex === 0 ? '실시간' : '최근 12시간' }} 가동률</span>
                <el-select v-model="availSelectedAgent" placeholder="데이터가 없습니다.">
                  <el-option v-for="agent in agentList" :key="agent.value" :label="agent.objName" :value="agent.objId" />
                </el-select>
              </el-row>
              <!-- BODY -->
              <ul class="event-info-list" v-if="availViewIndex === 0" slot="perfBody">
                <w-perf-body-info v-for="data in availData.frontBody" :key="data.widgetKey" :widget-info="data" />
              </ul>
              <w-summary-line-chart v-else slot="perfBody" :series="availData.backBody"></w-summary-line-chart>
              <!-- FOOTER -->
              <ul class="multi" v-if="availViewIndex === 0" slot="perfFooter">
                <w-perf-footer-h-info v-for="data in availData.frontFooter" style="width: 100%;" :key="data.widgetKey" :widget-info="data" />
              </ul>
              <ul class="legend list" v-else slot="perfFooter">
                <w-perf-footer-v-info v-for="data in availData.backFooter" :key="data.widgetKey" :widget-info="data" />
              </ul>
              </w-perf-widget>
            </el-col>
            <el-col :md="12" :lg="12">
              <w-perf-widget @change-widget-view="changeWidgetView('STATUSCODE', ...arguments)" :show-change-btn="false" :eventlevel="statuscodeData.eventlevel">
              <el-row style="width: calc(100% - 40px);" type="flex" slot="perfHeader" justify="space-between">
                <span>{{ statuscodeViewIndex === 0 ? '응답 상태 코드' : '최근 12시간 상태코드 장애 발생 수' }}</span>
                <el-select v-model="statuscodeSelectedAgent" placeholder="데이터가 없습니다.">
                  <el-option v-for="agent in agentList" :key="agent.value" :label="agent.objName" :value="agent.objId" />
                </el-select>
              </el-row>
              <!-- BODY -->
              <ul class="event-info-list" v-if="statuscodeViewIndex === 0" slot="perfBody">
                <w-perf-body-info v-for="data in statuscodeData.frontBody" :key="data.widgetKey" :widget-info="data" />
              </ul>
              <w-summary-column-chart v-else slot="perfBody" :series="statuscodeData.backBody"></w-summary-column-chart>
              <!-- FOOTER -->
              <ul class="multi" v-if="statuscodeViewIndex === 0" slot="perfFooter">
                <w-perf-footer-h-info v-for="data in statuscodeData.frontFooter" style="width: 100%;" :key="data.widgetKey" :widget-info="data" />
              </ul>
              <ul class="legend list" v-else slot="perfFooter">
                <w-perf-footer-v-info v-for="data in statuscodeData.backFooter" :key="data.widgetKey" :widget-info="data" />
              </ul>
              </w-perf-widget>
            </el-col>
          </div>
        </el-row>
      </div>
    </el-scrollbar>
    <w-scroll-top-button :visible="enableScollTop" @move-scroll-top="moveScrollTop"/>
  </div>
</template>

<script>
import clone from 'lodash/clone';
import isEmpty from 'lodash/isEmpty';
import isNil from 'lodash/isNil';
import moment from 'moment';
import { mapGetters } from 'vuex';
import ScrollbarMixin from '@/mixins/scrollbar';
import { EMPTY_TEXT } from '@/utils/string';
import { E2E } from '@/constants/summary';
import e2eApi from '@/api/performance/e2e/e2e-info';
import summaryApi from '@/api/performance/summary/summary-info';
import { getIntervalDatetimeParams } from '@/utils/date';
import WPerfWidget from '../components/PerfWidget';
import WPerfBodyInfo from '../components/PerfBodyInfo';
import WPerfFooterVInfo from '../components/PerfFooterVInfo';
import WPerfFooterHInfo from '../components/PerfFooterHInfo';
import WOperationStateInfo from '../components/OperationStateInfo';
import WSummaryLineChart from '../components/SummaryLineChart';
import WSummaryColumnChart from '../components/SummaryColumnChart';
import WSummaryAreaChart from '../components/SummaryAreaChart';
import WEventInfoWidget from '../components/EventInfoWidget';

export default {
  name: 'WPerformanceE2ESummary',
  mixins: [ScrollbarMixin],
  components: {
    WPerfWidget,
    WPerfBodyInfo,
    WPerfFooterVInfo,
    WPerfFooterHInfo,
    WOperationStateInfo,
    WSummaryLineChart,
    WSummaryColumnChart,
    WSummaryAreaChart,
    WEventInfoWidget,
  },
  props: {
    active: {
      type: Boolean,
      defulat: () => false,
    },
  },
  data() {
    return {
      params: {
        managetypeId: 'E2E',
      },
      agentList: [
        { objId: 0, objName: '-', agentId: 0 },
      ],
      responsetimeSelectedAgent: null,
      availSelectedAgent: null,
      statuscodeSelectedAgent: null,
      responsetimeViewIndex: 1,
      availViewIndex: 1,
      statuscodeViewIndex: 1,
      responsetimeData: { frontBody: [], backBody: [], frontFooter: [], backFooter: [], eventlevel: null },
      availData: { frontBody: [], backBody: [], frontFooter: [], backFooter: [], eventlevel: null },
      statuscodeData: { frontBody: [], backBody: [], frontFooter: [], backFooter: [], eventlevel: null },
      configInfoData: {},
      eventInfoData: {},
      operationStateParams: { rsctypeId: 'SERVICESTATUS', rscId: 'SERVICE_STATUS' },
    };
  },
  computed: mapGetters(['selectedNode']),
  watch: {
    selectedNode() {
      this.selectedAgent = null;
      this.loadData();
    },
    responsetimeSelectedAgent() {
      // 위젯 데이터 reload
      if (this.responsetimeSelectedAgent) {
        this.changeWidgetView('RESPONSETIME', this.responsetimeViewIndex);
      }
    },
    availSelectedAgent() {
      // 위젯 데이터 reload
      if (this.availSelectedAgent) {
        this.changeWidgetView('AVAIL', this.availViewIndex);
      }
    },
    statuscodeSelectedAgent() {
      // 위젯 데이터 reload
      if (this.statuscodeSelectedAgent) {
        this.changeWidgetView('STATUSCODE', this.statuscodeViewIndex);
      }
    },
    active: {
      handler() {
        this.loadData();
      },
    },
  },
  created() {
    this.loadData();
  },
  mounted() {
    this.setScrollData();
  },
  methods: {
    getIntervalDatetimeParams,
    loadData(isTaskLoad) {
      if (this.active) {
        const startDatetime = this.getIntervalDatetimeParams(new Date(), 'hour', 12);
        Object.assign(this.params, {
          transactionServiceId: this.selectedNode.serviceId,
          transactionId: this.selectedNode.transactionId,
          rscKey: this.selectedNode.rscKey,
          startDatetime,
        });
        // task로 인한 load일 경우 콤보박스에 선택된 데이터가 변경되지 않기 위해 처리
        if (isTaskLoad) {
          this.changeWidgetView('RESPONSETIME', this.responsetimeViewIndex);
          this.changeWidgetView('AVAIL', this.availViewIndex);
          this.changeWidgetView('STATUSCODE', this.statuscodeViewIndex);
        } else {
          this.responsetimeSelectedAgent = null;
          this.availSelectedAgent = null;
          this.statuscodeSelectedAgent = null;

          // 응답시간 위젯 : Agent 리스트 조회
          e2eApi.getE2EAgentList(this.params).then((response) => {
            this.agentList = response.data.data;
            this.responsetimeSelectedAgent = this.agentList[0].objId;
            this.availSelectedAgent = this.agentList[0].objId;
            this.statuscodeSelectedAgent = this.agentList[0].objId;
            this.loadConfInfoView(); // 구성정보 위젯 로드
            this.loadEventInfo(); // 이벤트 위젯 로드
          });
        }
      }
    },
    changeWidgetView(widgetKey, viewIndex) {
      const widgetKeyLower = widgetKey.toLowerCase();
      this[`${widgetKeyLower}ViewIndex`] = viewIndex;

      // 데이터 로드
      if (this[`${widgetKeyLower}ViewIndex`] === 0) {
        // 전면 데이터 로드 함수 호출
        this.loadFrontData(widgetKey);
      } else {
        // 후면 데이터 로드 함수 호출
        this.loadBackData(widgetKey);
      }
    },
    loadFrontData(widgetKey) {
      const widgetParam = clone(this.params);
      const rscParam = E2E.FRONT[widgetKey];
      let rscInfoList = [];
      if (!isEmpty(rscParam)) {
        rscInfoList = rscParam;
      } else {
        rscInfoList = E2E.FRONT[widgetKey].TOTAL;
      }

      Object.assign(widgetParam, {
        summaryWidgetKey: widgetKey,
        rscInfoList,
        objId: this[`${widgetKey.toLowerCase()}SelectedAgent`],
      });

      e2eApi.getE2ESummaryRscRsltList(widgetParam).then((response) => {
        if (response.data.success) {
          this[widgetKey.toLowerCase().concat('Data')].frontBody = response.data.data.body;
          this[widgetKey.toLowerCase().concat('Data')].frontFooter = response.data.data.footer;
        }
      });
    },
    loadBackData(widgetKey) {
      const widgetParam = clone(this.params);
      const rscParam = E2E.BACK[widgetKey];
      let rscInfoList = [];
      if (!isEmpty(rscParam)) {
        rscInfoList = rscParam;
      } else {
        rscInfoList = E2E.BACK[widgetKey].TOTAL;
      }
      Object.assign(widgetParam, {
        summaryWidgetKey: widgetKey,
        rscInfoList,
        objId: this[`${widgetKey.toLowerCase()}SelectedAgent`],
      });

      e2eApi.getE2ESummaryRscRsltBackList(widgetParam).then((response) => {
        if (response.data.success) {
          this[widgetKey.toLowerCase().concat('Data')].backBody = response.data.data.body;
          this[widgetKey.toLowerCase().concat('Data')].backFooter = response.data.data.footer;
          this[widgetKey.toLowerCase().concat('Data')].eventlevel = response.data.data.eventlevel;
        }
      });
    },
    /**
     * 구성 정보 load
     * @author jeee12
     */
    loadConfInfoView() {
      e2eApi.getE2EConfigurationInfo({
        transactionId: this.selectedNode.transactionId,
        serviceId: this.selectedNode.serviceId,
      }).then((response) => {
        if (response.data.success) {
          const configInfo = response.data.data;
          // 측정 Agent명
          // FIXME 설계 변경시 수정 필요
          configInfo.agentLabel = EMPTY_TEXT;
          if (configInfo.agentCount > 0) {
            configInfo.agentLabel = `${configInfo.agentIpaddress} (${configInfo.agentName})`;
            if (configInfo.agentCount > 1) configInfo.agentLabel += ` 외 ${configInfo.agentCount - 1}개`;
          }
          // 문자열 정합성 여부
          if (configInfo.httpAdjustType === 'N') {
            configInfo.adjustLabel = '미사용';
          } else {
            configInfo.adjustLabel = `${configInfo.httpAdjustText}`;
            if (configInfo.httpAdjustType === 'G') configInfo.adjustLabel += ' (포함)';
            else if (configInfo.httpAdjustType === 'B') configInfo.adjustLabel += ' (제외)';
          }

          let majorLabel = EMPTY_TEXT;
          let minorLabel = EMPTY_TEXT;

          if (configInfo.majorName) {
            majorLabel = configInfo.majorDepartment ? `[${configInfo.majorDepartment}]${configInfo.majorName}` : `[${EMPTY_TEXT}]${configInfo.majorName}`;
          }
          if (configInfo.minorName) {
            minorLabel = configInfo.minorDepartment ? `[${configInfo.minorDepartment}]${configInfo.minorName}` : `[${EMPTY_TEXT}]${configInfo.minorName}`;
          }
          configInfo.majorLabel = majorLabel;
          configInfo.minorLabel = minorLabel;
          // configInfo.httpParam = !isEmpty(configInfo.httpParam) ? configInfo.httpParam.split('=')[1] : EMPTY_TEXT;
          configInfo.httpParam = !isEmpty(configInfo.httpParam) ? configInfo.httpParam : EMPTY_TEXT;
          configInfo.checkDatetimeLabel = !isNil(configInfo.checkDatetime) ? moment(configInfo.checkDatetime).format('YYYY년 MM월 DD일 HH:mm:ss') : EMPTY_TEXT;
          this.configInfoData = configInfo;
        }
      });
    },
    /**
     * 이벤트 정보 조회
     * @author jeee12
     */
    loadEventInfo() {
      const eventParam = clone(this.params);
      const objIds = [];
      eventParam.endDatetime = new Date().getTime();
      if (!isEmpty(this.agentList)) {
        this.agentList.forEach((agent) => {
          objIds.push(agent.objId);
        });
        eventParam.objIds = objIds;
      }

      summaryApi.getSummaryEventInfo(eventParam).then((response) => {
        if (response.data.success) {
          this.eventInfoData = response.data.data;
        }
      });
    },
    /**
     * 후면 body 데이터 중 footer 데이터의 인덱스 검색
     * @author jeee12
     * @param  {[type]} backBodySeries [description]
     * @param  {[type]} footer         [description]
     * @return {[type]}                [description]
     */
    findFooterIndex(backBodySeries, footer) {
      return backBodySeries.findIndex((e) => {
        if (footer.rsckey) {
          return e.rscInfo.rscKeyName === footer.rscKeyName;
        } else if (e.rscInfo) {
          return e.rscInfo.rsctypeId === footer.rsctypeId && e.rscInfo.rscId === footer.rscId;
        }
        return null;
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/performance/node/summary/e2e/index.vue